import { createTopic } from '../lib';
import { z } from 'zod';

const marketplaceHomeNavigatedEventSchema = z.object({
  path: z.string(),
});

export type MarketplaceHomeNavigatedEvent = z.infer<
  typeof marketplaceHomeNavigatedEventSchema
>;

export const marketplaceHomeNavigatedTopic =
  createTopic<MarketplaceHomeNavigatedEvent>(
    {
      namespace: 'marketplace',
      name: 'home-navigated',
      description: 'User navigated to the marketplace home page.',
    },
    marketplaceHomeNavigatedEventSchema,
  );
